import { create } from 'zustand';
import { Storefront } from '../types/Storefront';

interface StoreListStore {
  stores: Storefront[];
  setStoreList: (stores: Storefront[]) => void;
}

export const useStoreListStore = create<StoreListStore>((set) => ({
  stores: [],
  setStoreList: (stores: Storefront[]) => set({ stores }),
}));
